import React, { useState, useCallback, useEffect } from "react";

import {
    Box,
    Button,
    Divider,
    TextField,
    Grid,
    Card,
    styled,
    Typography,
    IconButton,
    List,
    ListItem,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormGroup,
    Checkbox,
    FormHelperText,
    FormControlLabel,
    InputAdornment
} from '@mui/material';

import _ from "lodash";

import { grey } from "@mui/material/colors";

import * as Yup from "yup";

import { useFormik } from 'formik';

import { CommonIcons, icons } from "../../../../../../components/common/CommonIcons";
import { useSystemPrompt } from "../../../../../../hooks/useSystemPrompt";

import { useTranslations } from "../../../../../../hooks/useTranslations";

import {
    useProduct,
    initialItemValues,
    validateItemSchema as validateItemSchema1,
    calculateCbmByDimension
} from "../../../../hooks/model/useProduct"

import {
    defaultUom,
    getUniqueItemCode,
    itemUoms,
    // itemInjectionProps
} from "../../../../hooks/model/useProductItem"

import { useAuthAccess } from "../../../../../../hooks/useAuthAccess"

import { checkValueExists, mergeSchema } from "../../../../../../utils/dataSchema"

import { formatRoundValue } from "../../../../utils/formatNumber"

const maxItemLength = 30

export const validateItemSchema2 = Yup.object().shape({
    customUomName: Yup
        .string()
        .required("Required")
})

const validateItemSchema = mergeSchema(validateItemSchema1, validateItemSchema2)

export const validationSchema = Yup.object({
    items: Yup.array().of(validateItemSchema),
})

export const initialValues = {
    items: [
        initialItemValues
    ],
    isDeleteFirstRowOfSavedItems: false
}
// console.log('initialValues', initialValues)

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));


const StyledBox = styled(Box)(({ theme }) => ({
    padding: 1
}));

const StyledBoxSummary = styled(Box)(({ theme }) => ({
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 3,
    paddingBottom: 3,
    // borderWidth: 1,
    // borderStyle: "solid",
    backgroundColor: grey[200],
    marginRight: 5,
    textAlign: 'center',
    minWidth: 100,
    borderRadius: 10,
}));

const RenderFormRow = (props) => {

    let {
        t,
        formik,
        itemValues,
        itemErrors,
        index,
        summaryItems,
        handleRemoveRow
        // handleChange
    } = props

    // get summary of the items
    let summary = summaryItems[index]

    let { values, errors, handleChange, setFieldValue } = formik

    let uomValue = ''

    // getting the uom name
    let a = itemUoms.filter(i => i.translation.includes(itemValues.customUomName) === true)

    // console.log('aa', values[itemInjectionFields.uomName.submitKey], itemUoms, a)

    if (a.length > 0) {

        // console.log('a[0].value', a[0].value)

        uomValue = t(a[0].display)
    }

    return (
        <ListItem
            sx={{
                p: 0,
                m: 0,
                py: 0.5
            }}
            divider
        >
            <Grid container spacing={1}>

                <Grid item xs={12} sm={12} md={0.3} alignSelf={"center"}>

                    <IconButton
                        onClick={() => {
                            handleRemoveRow({ removeIndex: index })
                        }}
                    >
                        <CommonIcons name={icons.remove} />
                    </IconButton>

                </Grid>

                <Grid item xs={12} sm={12} md={1.3} alignSelf={"center"}>

                    <TextField
                        autoComplete="off"
                        margin="dense"
                        size="small"
                        // autoFocus
                        fullWidth
                        name={`items.${index}.remark`}
                        label={`${t('model')} #${(index + 1)}`}
                        type="text"
                        variant="outlined"
                        value={itemValues?.remark ? itemValues.remark : ""}
                        onChange={handleChange}
                        error={Boolean(itemErrors?.remark)}
                    // helperText={itemErrors?.remark}
                    />

                </Grid>

                <Grid item xs={12} sm={12} md={1} alignSelf={"center"}>

                    <TextField
                        autoComplete="off"
                        margin="dense"
                        size="small"
                        // autoFocus
                        fullWidth
                        name={`items.${index}.description`}
                        label={`${t('itemName')} #${(index + 1)}`}
                        type="text"
                        variant="outlined"
                        value={itemValues?.description ? itemValues.description : ""}
                        onChange={handleChange}
                        error={Boolean(itemErrors?.description)}
                    // helperText={itemErrors?.description}
                    />

                </Grid>

                <Grid item xs={12} sm={12} md={0.8} alignSelf={"center"}>

                    <TextField
                        autoComplete="off"
                        margin="dense"
                        size="small"
                        // autoFocus
                        fullWidth
                        name={`items.${index}.handleQty`}
                        label={t('handleQty')}
                        type="text"
                        variant="outlined"
                        value={itemValues?.handleQty ? itemValues.handleQty : ""}
                        // onChange={handleChange}
                        onChange={(e) => {

                            let val = e.target.value

                            setFieldValue(`items.${index}.handleQty`, val)

                            // setNeedRecalculate(true)

                        }}
                        error={Boolean(itemErrors?.handleQty)}
                    // helperText={itemErrors?.handleQty}
                    />

                </Grid>

                <Grid item xs={12} sm={12} md={0.8} alignSelf={"center"}>

                    <TextField
                        autoComplete="off"
                        margin="dense"
                        size="small"
                        // autoFocus
                        fullWidth
                        name={`items.${index}.uomPrice`}
                        label={t('unitPrice')}
                        type="text"
                        variant="outlined"
                        value={itemValues?.uomPrice ? itemValues.uomPrice : ""}
                        // onChange={handleChange}
                        onChange={(e) => {

                            let val = e.target.value

                            setFieldValue(`items.${index}.uomPrice`, val)

                            // setNeedRecalculate(true)

                        }}
                        error={Boolean(itemErrors?.uomPrice)}
                    // helperText={itemErrors?.uomPrice}
                    />

                </Grid>

                <Grid item xs={12} sm={12} md={0.8} alignSelf={"center"}>

                    <TextField
                        autoComplete="off"
                        margin="dense"
                        size="small"
                        // autoFocus
                        fullWidth
                        name={`items.${index}.handleQtyPerPackage`}
                        label={t('pcsCtn')}
                        type="text"
                        variant="outlined"
                        value={itemValues?.handleQtyPerPackage ? itemValues.handleQtyPerPackage : ""}
                        onChange={handleChange}
                        error={Boolean(itemErrors?.handleQtyPerPackage)}
                    // helperText={itemErrors?.remark}
                    />

                </Grid>


                <Grid item xs={12} sm={12} md={0.8} alignSelf={"center"}>

                    <TextField
                        autoComplete="off"
                        margin="dense"
                        size="small"
                        // autoFocus
                        fullWidth
                        name={`items.${index}.length`}
                        label={t('length')}
                        type="text"
                        variant="outlined"
                        value={itemValues?.length}
                        // onChange={handleChange}
                        onChange={(e) => {

                            let val = e.target.value

                            setFieldValue(`items.${index}.length`, val)

                            // setNeedRecalculate(true)

                        }}
                        error={Boolean(itemErrors?.length)}
                    // helperText={itemErrors?.paymentType}
                    />

                </Grid>

                <Grid item xs={12} sm={12} md={0.8} alignSelf={"center"}>

                    <TextField
                        autoComplete="off"
                        margin="dense"
                        size="small"
                        // autoFocus
                        fullWidth
                        name={`items.${index}.width`}
                        label={t('width')}
                        type="text"
                        variant="outlined"
                        value={itemValues?.width}
                        // onChange={handleChange}
                        onChange={(e) => {

                            let val = e.target.value

                            setFieldValue(`items.${index}.width`, val)

                            // setNeedRecalculate(true)

                        }}
                        error={Boolean(itemErrors?.width)}
                    // helperText={itemErrors?.width}
                    />

                </Grid>

                <Grid item xs={12} sm={12} md={0.8} alignSelf={"center"}>

                    <TextField
                        autoComplete="off"
                        margin="dense"
                        size="small"
                        // autoFocus
                        fullWidth
                        name={`items.${index}.height`}
                        label={t('height')}
                        type="text"
                        variant="outlined"
                        value={itemValues?.height}
                        // onChange={handleChange}
                        onChange={(e) => {

                            let val = e.target.value

                            setFieldValue(`items.${index}.height`, val)

                            // setNeedRecalculate(true)

                        }}
                        error={Boolean(itemErrors?.height)}
                    // helperText={itemErrors?.height}
                    />

                </Grid>

                <Grid item xs={12} sm={12} md={0.8} alignSelf={"center"}>

                    <TextField
                        autoComplete="off"
                        margin="dense"
                        size="small"
                        // autoFocus
                        fullWidth
                        name={`items.${index}.qty`}
                        label={t('packUnit')}
                        type="text"
                        variant="outlined"
                        value={itemValues?.qty ? itemValues.qty : ""}
                        // onChange={handleChange}
                        onChange={(e) => {

                            let val = e.target.value

                            setFieldValue(`items.${index}.qty`, val)

                            // setNeedRecalculate(true)

                        }}
                        error={Boolean(itemErrors?.qty)}
                    // helperText={itemErrors?.qty}
                    />

                </Grid>

                <Grid item xs={12} sm={12} md={0.8} alignSelf={"center"}>

                    <TextField
                        autoComplete="off"
                        margin="dense"
                        size="small"
                        // autoFocus
                        fullWidth
                        name={`items.${index}.weight`}
                        label={t('weight')}
                        type="text"
                        variant="outlined"
                        value={itemValues?.weight ? itemValues.weight : ""}
                        // onChange={handleChange}
                        onChange={(e) => {

                            let val = e.target.value

                            setFieldValue(`items.${index}.weight`, val)

                            // setNeedRecalculate(true)

                        }}
                        error={Boolean(itemErrors?.weight)}
                    // helperText={itemErrors?.weight}
                    />

                </Grid>



                <Grid item xs={12} sm={12} md={0.8} alignSelf={"center"}>

                    <FormControl
                        margin="dense"
                        fullWidth
                        size="small"
                        error={Boolean(itemErrors?.customUomName)}
                    >
                        <InputLabel id="uomName">{t('uom')}</InputLabel>
                        <Select
                            labelId="uomName"
                            label="uomName"
                            name={'customUomName'}
                            onChange={(event) => {
                                setFieldValue(`items.${index}.customUomName`, event.target.value);
                            }}
                            // value={checkValueExists({
                            //     dataSearch: itemUoms,
                            //     valueToCompare: itemValues?.customUomName,
                            //     searchFieldId: `value`
                            // })}
                            value={uomValue}
                            sx={{
                                textAlign: 'left',
                            }}
                        >
                            {itemUoms.map((i, index) => {
                                return (
                                    // <MenuItem key={index} value={i.value}>
                                    //     {i.display}
                                    // </MenuItem>
                                    <MenuItem key={index} value={t(i.display)}>
                                        {t(i.display)}
                                    </MenuItem>
                                );
                            })}
                        </Select>
                        <FormHelperText>{itemErrors?.customUomName}</FormHelperText>
                    </FormControl>


                </Grid>


                <Grid item xs={12} sm={12} md={2} display={"flex"} flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"}>

                    {/* <Typography
                            sx={{
                                fontSize: 9
                            }}
                        >
                            {
                                JSON.stringify(summary)
                            }
                        </Typography> */}

                    <StyledBox>
                        <Typography
                            sx={{
                                fontSize: 10
                            }}
                        >
                            {`${t('tValue')} : `}
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: 12
                            }}
                        >
                            {/* {` ${itemValues?.totalValue ? itemValues.totalValue : 0}`} */}
                            {` ${summary?.totalValue ? summary.totalValue : 0}`}
                        </Typography>
                    </StyledBox>


                    <StyledBox>
                        <Typography
                            sx={{
                                fontSize: 10
                            }}
                        >
                            {`${t('cbm')} : `}
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: 12
                            }}
                        >
                            {/* {` ${itemValues?.cbm ? itemValues.cbm : 0}`} */}
                            {` ${summary?.cbm ? summary.cbm : 0}`}
                        </Typography>
                    </StyledBox>

                    <StyledBox>
                        <Typography
                            sx={{
                                fontSize: 10
                            }}
                        >
                            {`${t('tCbm')} : `}
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: 12
                            }}
                        >
                            {/* {` ${itemValues?.totalCbm ? itemValues.totalCbm : 0}`} */}
                            {` ${summary?.totalCbm ? summary.totalCbm : 0}`}
                        </Typography>
                    </StyledBox>


                    <StyledBox>
                        <Typography
                            sx={{
                                fontSize: 10
                            }}
                        >
                            {`${t('tWeight')} : `}
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: 12
                            }}
                        >
                            {/* {` ${itemValues?.totalWeight ? itemValues.totalWeight : 0}`} */}
                            {` ${summary?.totalWeight ? summary.totalWeight : 0}`}
                        </Typography>
                    </StyledBox>


                </Grid>


            </Grid>
        </ListItem>
    )
}

const RenderForm = ({ t, formik, summaryItems, handleAddRow, handleRemoveRow, allowDeleteFirstRowAfterSave = false, printPackQtyValue }) => {

    const { values, errors, handleChange } = formik

    // console.log('summaryItems', summaryItems)

    const [insertRowsCount, setInsertRowsCount] = useState(1)

    // calculate balance left the max row allowed
    let leftRowAllowed = Number(maxItemLength) - Number(values.items.length - 1)

    let valueInsertRowsNo = 0

    if (insertRowsCount <= leftRowAllowed) {
        valueInsertRowsNo = Number(insertRowsCount)
    } else {
        valueInsertRowsNo = leftRowAllowed
    }

    let summary = {
        totalQty: 0,
        totalCbm: 0,
        totalValue: 0,
        totalWeight: 0
    }

    // get summary of rows
    summaryItems.forEach(i => {
        // console.log('i', i)
        summary.totalQty += parseFloat(i?.totalQty)
        summary.totalCbm += parseFloat(i?.totalCbm)
        summary.totalValue += parseFloat(i?.totalValue)
        summary.totalWeight += parseFloat(i?.totalWeight)

    })

    summary.totalQty = formatRoundValue(parseFloat(summary.totalQty), 0).toFixed(0)
    summary.totalCbm = formatRoundValue(parseFloat(summary.totalCbm), 4).toFixed(4)
    summary.totalValue = formatRoundValue(parseFloat(summary.totalValue), 2).toFixed(2)
    summary.totalWeight = formatRoundValue(parseFloat(summary.totalWeight), 4).toFixed(4)

    return (

        <form onSubmit={formik.handleSubmit}>

            <Box
                sx={{
                    mt: 0,
                    mb: 2,
                    mx: 2
                }}
            >
                <Grid container spacing={0}>
                    <Grid
                        item xs={10} md={10} sm={10}
                        display={"flex"} flexDirection={"row"} justifyContent={"flex-start"} alignItems={"flex-end"}
                    >
                        <StyledBoxSummary>
                            <Typography sx={{ fontSize: 11, }}>
                                {`${t('printPackQty')} : `}
                            </Typography>
                            <Typography sx={{ fontSize: 14, fontWeight: 600 }}>
                                {printPackQtyValue}
                            </Typography>
                        </StyledBoxSummary>

                        <StyledBoxSummary>
                            <Typography sx={{ fontSize: 11, }}>
                                {`${t('totalPackQty')} : `}
                            </Typography>
                            <Typography sx={{ fontSize: 14 }}>
                                {`${summary?.totalQty}`}
                            </Typography>
                        </StyledBoxSummary>

                        <StyledBoxSummary>
                            <Typography
                                sx={{
                                    fontSize: 11
                                }}
                            >
                                {`${t('totalValues')} : `}
                            </Typography>
                            <Typography
                                sx={{
                                    fontSize: 14,
                                }}
                            >
                                {` ${summary.totalValue}`}
                            </Typography>
                        </StyledBoxSummary>


                        <StyledBoxSummary>
                            <Typography
                                sx={{
                                    fontSize: 11
                                }}
                            >
                                {`${t('totalWeight')} : `}
                            </Typography>
                            <Typography
                                sx={{
                                    fontSize: 14
                                }}
                            >
                                {` ${summary.totalWeight}`}
                            </Typography>
                        </StyledBoxSummary>

                        <StyledBoxSummary>
                            <Typography
                                sx={{
                                    fontSize: 11
                                }}
                            >
                                {`${t('totalCbm')} : `}
                            </Typography>
                            <Typography
                                sx={{
                                    fontSize: 14
                                }}
                            >
                                {/* {` ${itemValues?.totalCbm ? itemValues.totalCbm : 0}`} */}
                                {` ${summary.totalCbm}`}
                            </Typography>
                        </StyledBoxSummary>
                    </Grid>

                    <Grid item xs={2} md={2} sm={2} display={"flex"} flexDirection={"row"} justifyContent={"flex-end"} alignItems={"center"}>
                        {/* <Grid container spacing={0}>
                            <Grid item xs={6} md={6} sm={6} alignSelf={"center"}>
                                <Typography
                                    sx={{
                                        flex: 1,
                                        textAlign: 'right',
                                        pr: 1
                                    }}
                                >
                                    {`${values.items.length} / ${maxItemLength}`}
                                </Typography>

                            </Grid>

                            <Grid item xs={6} md={6} sm={6} alignSelf={"center"}>
                                <Button
                                    type="button"
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    onClick={handleAddRow}
                                >
                                    <CommonIcons name={icons.plus} />
                                </Button>
                            </Grid>
                        </Grid> */}
                        <FormControl size="small">
                            <TextField
                                size='small'
                                id="insertRows"
                                name="insertRows"
                                label={t("insertRows")}
                                type="text"
                                value={
                                    valueInsertRowsNo
                                }
                                onChange={e => setInsertRowsCount(e.target.value)}
                                fullWidth
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <Button
                                                type="button"
                                                variant="contained"
                                                color="primary"
                                                fullWidth
                                                onClick={() => {
                                                    handleAddRow({ rowCount: insertRowsCount })
                                                }}
                                            >
                                                <CommonIcons name={icons.plus} />
                                            </Button>
                                        </InputAdornment>
                                    ),
                                }}
                                onFocus={event => {
                                    event.target.select();
                                }}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            </Box>

            {/* <StyledCard
                sx={{
                    px: 0,
                    py: 2,
                    mb: 1
                }}
            > */}
            <List
                sx={{
                    p: 0,
                    m: 0
                }}
            >
                {
                    values?.items.map((i, index) => {

                        let itemValues = i
                        let itemErrors = errors?.items

                        if (itemErrors) {
                            itemErrors = (itemErrors[index] !== undefined) ? itemErrors[index] : {};
                        }

                        return (
                            <Box
                                key={index}
                            >
                                <RenderFormRow
                                    t={t}
                                    handleRemoveRow={handleRemoveRow}
                                    formik={formik}
                                    summaryItems={summaryItems}
                                    itemValues={itemValues}
                                    itemErrors={itemErrors}
                                    index={index}
                                />
                            </Box>
                        )
                    })
                }
            </List>
            {/* </StyledCard> */}

            <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                <Grid item md={12} textAlign={"right"}>
                    <Box
                        display={"flex"}
                        flexDirection={"row"}
                        justifyContent={"flex-end"}
                        alignItems={"center"}
                    >
                        {
                            allowDeleteFirstRowAfterSave === true &&
                            (
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={values?.isDeleteFirstRowOfSavedItems}
                                                onChange={handleChange}
                                                id={"isDeleteFirstRowOfSavedItems"}
                                                name={"isDeleteFirstRowOfSavedItems"}
                                            />
                                        }
                                        label={`${t("deleteFirstRowOfSavedItems")}`}
                                    />
                                </FormGroup>
                            )
                        }

                        <Button
                            type="submit"
                            // fullWidth
                            variant="contained"
                            sx={{
                                mt: 3,
                                mb: 2
                            }}
                        >
                            {t('saveChanges')}
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </form >

    )
}

export default function AddProductItems({
    routeType,
    currentData,
    productId,
    productIndex,
    courierTrackingNo,
    onSaveSuccess = () => { },
    allowDeleteFirstRowAfterSave = false,
    printPackQtyValue
}) {

    const { promptMessage } = useSystemPrompt();

    const { t } = useTranslations({ ns: ["_@products", "_prompt", "_@repositories", "_@parcel", "common", "_common"] })

    const { authData } = useAuthAccess(routeType)

    const { updateLastUpdateProduct } = useProduct({ routeType })

    const [summaryItems, setSummaryItems] = useState([])

    const authDataUserId = `${authData?.profile?.user?.id}`
    const authDataUserDisplay = `${authData?.profile?.user?.username}`

    const onSubmit = async (currentValues) => {

        let totalWeight = 0
        let totalCbm = 0
        let totalValue = 0

        let _currentValuesItems = []

        currentValues.items.forEach((i4, index4) => {

            // console.log('i4', i4)

            let summary = summaryItems[index4]

            let _cbm = parseFloat(summary?.cbm)
            let _totalWeight = parseFloat(summary?.totalWeight)
            let _totalValue = parseFloat(summary?.totalValue)
            let _totalCbm = parseFloat(summary?.totalCbm)

            totalWeight += _totalWeight
            totalCbm += _totalCbm
            totalValue += _totalValue

            _currentValuesItems.push({
                ...i4,
                cbm: formatRoundValue(_cbm, 4).toFixed(4),
                totalCbm: formatRoundValue(_totalCbm, 4).toFixed(4),
                totalWeight: formatRoundValue(_totalWeight, 4).toFixed(4),
                totalValue: formatRoundValue(_totalValue, 2).toFixed(2)
            })

        })

        currentValues.items = _currentValuesItems

        // summary total
        let totalSummary = {
            weight: totalWeight.toFixed(4),
            cbm: totalCbm.toFixed(4),
            value: totalValue.toFixed(2),
        }

        // console.log('currentValues', currentValues, totalSummary)

        if (onSaveSuccess) {
            onSaveSuccess(currentValues, productIndex, totalSummary, currentValues?.isDeleteFirstRowOfSavedItems,)
        }

        promptMessage(true, `Entry #${(productIndex + 1)} : Items (${currentValues.items.length}) has been saved`)

        return true
    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit
    });

    const { values, errors, touched, handleChange, setFieldValue } = formik;

    const generateRowId = () => {
        return _.uniqueId("")
    }

    useEffect(() => {

        // console.log('currentData', currentData)

        if (currentData.length <= 0) {
            setFieldValue(
                `items`,
                [{
                    ...initialItemValues,
                    id: generateRowId(),
                    uomId: defaultUom.id,
                    // customUomName: defaultUom.uomName,
                    customUomName: t(defaultUom.value),
                    code: getUniqueItemCode({ courierTrackingNo, productId: 'TEMP' }),
                }]
            )
        } else {
            setFieldValue(`items`, currentData)
        }

    }, [])

    useEffect(() => {

        let currentItems = values.items
        let newItems = []

        // const divideNo = 1000000

        currentItems.forEach((i, index) => {

            // let totalValue = values.items.reduce((total, item) => {

            console.log('get pack qty', i)

            let unitPrice = parseFloat(i.uomPrice)
            let handleQty = parseFloat(i.handleQty)
            let qty = parseFloat(i.qty)
            let weight = parseFloat(i.weight)

            let width = parseFloat(i.width)
            let height = parseFloat(i.height)
            let length = parseFloat(i.length)

            let value = unitPrice * handleQty

            let totalValue = parseFloat(value)

            let cbm = calculateCbmByDimension({ w: width, h: height, l: length })

            // console.log('total:: ', totalValue, cbm)

            let totalCbm = cbm * qty
            let totalWeight = weight * qty
            let totalQty = parseFloat(qty)

            if (Number.isNaN(totalValue)) totalValue = 0
            if (Number.isNaN(totalCbm)) totalCbm = 0
            if (Number.isNaN(totalWeight)) totalWeight = 0
            if (Number.isNaN(totalCbm)) totalCbm = 0
            if (Number.isNaN(totalQty)) totalQty = 0

            newItems.push({
                // ...currentItems[index],
                totalQty: formatRoundValue(parseFloat(totalQty), 4).toFixed(4),
                cbm: formatRoundValue(parseFloat(cbm), 4).toFixed(4),
                totalValue: formatRoundValue(parseFloat(totalValue), 2).toFixed(2),
                totalCbm: formatRoundValue(parseFloat(totalCbm), 4).toFixed(4),
                totalWeight: formatRoundValue(parseFloat(totalWeight), 4).toFixed(4),
            })

        })

        // console.log('newItems', newItems)

        // setFieldValue(`items`, newItems)
        setSummaryItems(newItems)

    }, [values.items])

    return (
        <Box
            sx={{
                mx: -1
            }}
        >

            {/* {JSON.stringify(values)} */}

            <RenderForm
                t={t}
                formik={formik}
                summaryItems={summaryItems}
                printPackQtyValue={printPackQtyValue}
                // handleAddRow={() => {
                //     // let newTabValue = values.products.length

                //     if (values.items.length >= maxItemLength) {
                //         promptMessage(false, `Max only ${maxItemLength}`)
                //         return false
                //     }

                //     setFieldValue(
                //         `items`,
                //         [
                //             ...values.items,
                //             {
                //                 ...initialItemValues,
                //                 uomId: values.items[0].uomId,
                //                 code: getUniqueItemCode({ courierTrackingNo, productId: values.items[0].productId }),
                //                 productId: values.items[0].productId
                //             }
                //         ]
                //     )
                //     // setTabValue(newTabValue)
                //     promptMessage(true, t('added1NewItemEntry'))

                //     return true
                // }}
                handleAddRow={({ rowCount = 1 }) => {

                    rowCount = parseInt(rowCount, 10)

                    if ((values.items.length + rowCount) > maxItemLength) {
                        promptMessage(false, `${t('maxOnly')} ${maxItemLength}`)
                        return false
                    }

                    let newItems = [...Array(rowCount)].map((_, i) => {
                        return {
                            ...initialItemValues,
                            id: generateRowId(),
                            uomId: values.items[0].uomId,
                            code: getUniqueItemCode({ courierTrackingNo, productId: values.items[0].productId }),
                            productId: values.items[0].productId,
                            customUomName: t(initialItemValues.customUomName)
                        }
                    })

                    setFieldValue(`items`, [
                        ...values.items,
                        ...newItems
                    ])

                    promptMessage(true, t('added1NewItemEntry'))

                    return true

                }}
                handleRemoveRow={({ removeIndex }) => {

                    if (values.items.length <= 1) {
                        promptMessage(false, `${t("mustSelectAtLeast1Selection")}`)
                        return false
                    }

                    setFieldValue(
                        `items`,
                        values.items.filter((i, ind) => ind !== removeIndex)
                    )
                    return true

                }}
                allowDeleteFirstRowAfterSave={allowDeleteFirstRowAfterSave}
            />

        </Box>
    )
}